<template>
    <div>
        <router-view v-if="isShowRouter"></router-view>
    </div>
</template>
<script>
    import 'bbg-flexible'
    import Permission from './assets/js/permission-util.js'
    import CustomRouter from './router/custom-router.js'
    export default {
        data () {
            var Permission = Permission
            return {
                isShowRouter: false
            }
        },
        methods: {
            generateNewRouter: function (res) {
                // 动态增加router
                var addRouter = []
                // addRouter.push(CustomRouter)
                addRouter = CustomRouter
                // 根据动态生成的router匹配后端返回的路由
                var newRouter = Permission.router(addRouter, res.data.resources)
                newRouter.unshift({
                    path: '*',
                    redirect: '/404',
                    hidden: true
                })
                this.$router.options.routes = this.$router.options.routes.concat(newRouter)
                this.$router.addRoutes(newRouter)
            },
            getRouter(){
                // 动态增加router
                // 获得授权的路由
                var params={
                    loop:1,
                    systemCode:"AMP"
                }
                this.$ajax.get(this.$apiUrl.getResources,params).then(res=>{
                    if(res.error==0){
                        if(res.data.resources.length==0){
                            this.$message({
                                type:'warning',
                                message:'你没有任何权限！'
                            })
                            //退出登录，以防再次登录时无法登录
                                var url=this.$apiUrl.logoutUrl;
                                this.$ajax.get(url).then(res=>{
                                    if(res.error==0){
                                        //在调用refsession接口
                                        this.$ajax.get(this.$apiUrl.reSessionUrl).then(res=>{
                                            if(res.error==0){
                                            }
                                        })
                                    }
                                })
                                return;
                        }
                        //判断是否有店铺后台权限
                        localStorage.removeItem('shopmanage');
                        res.data.resources.forEach(v=>{
                            if(v.name=='跳转商户管理后台'){
                                localStorage.setItem('shopmanage','1')
                            }
                        })

                        //动态生成路由
                        this.generateNewRouter(res);
                        var firstRouter=res.data.resources[0];
                        var redirectRootPath=firstRouter.path;
                        var redirectName="";

                        this.$router.options.routes.forEach(v=>{
                            if(v.path==redirectRootPath){
                                redirectName=v.children[0].name;
                            }
                        })
                        if(window.location.pathname == '/' || window.location.pathname == ''){
                            this.$router.push({name:redirectName});
                        }
                    }
                    this.isShowRouter=true
                })
            }
        },
        mounted () {
            this.$ajax.get('//active.yunhou.com/api/member/getLoginUserInfo',{}).then(res=>{
                if(res && res.error ==0){
                  localStorage.setItem('currentUserBussinessTypeCode',res.data.sysUser.businessTypeCode)
                  sessionStorage.setItem('loginInfo', JSON.stringify(res.data.sysUser))
                }
                this.getRouter();
            })
        }
    }
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// App.vue?9b262808